import SearchIcon from "@mui/icons-material/Search";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Chip,
  InputAdornment,
  Snackbar,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import { DatePicker, DateValidationError } from "@mui/x-date-pickers";
import React, { useCallback, useEffect, useState } from "react";
import { getModalStyle } from "../../../modalStyle";
import GenericModal from "../../modals/GenericModal";
import PTRModal from "../../modals/PTRModal";
import {
  planoAPI,
  useAddPlanogrammeMutation,
  useGetEnsembleQuery,
  useGetSectionsQuery,
  useLazyGetBannieresQuery,
  useLazyGetDefaultSectionQuery,
  useUpdatePlanogrammeProduitsMutation,
} from "../../../../redux/features/cache";
import ListMagasinsModal from "../../modals/ListeMagasinsModal";
import { Dayjs } from "dayjs";
import { Section } from "../../../../models/Section";
import { Magasin } from "../../../../models/Magasin";
import { padZerosLeft } from "../../../../commons/helpers/StringHelper";
import { PTR_LENGTH } from "../../../../constante/produits";
import EditIcon from "@mui/icons-material/Edit";
import PlanoProduitsModal from "../../modals/PlanoProduitsModal";
import { ProduitQuantite } from "../../../../models/ProduitQuantite";
import {
  addRequestToSend,
  addRequestsToSend,
} from "../../../../redux/features/appStateSlice";
import { useAppDispatch } from "../../../../redux/store";
import { RequestToSend } from "../../../../models/RequestToSend";

export interface IFormNewProduitProps {
  row: number | null;
  listMagsPlano: Magasin[];
  activeSectionNum: number;
  prendLaPlaceDe: number | null;
  showMagList: boolean;
  defaultDisabled: boolean;
}

function FormNewProduit({
  listMagsPlano,
  row,
  activeSectionNum,
  prendLaPlaceDe,
  showMagList,
  defaultDisabled,
}: IFormNewProduitProps) {
  const { data: sections = [] as Section[] } = useGetSectionsQuery({
    div: "",
    simple: true,
    user: "",
    rech: "",
    treeView: false,
  });
  const [openProd, setOpenProd] = useState(false);
  const [openRemp, setOpenRemp] = useState(false);
  const [openMagasin, setOpenMagasins] = useState<boolean>(showMagList);
  const [showModalPlanoProduits, setShowModalPlanoProduits] =
    useState<boolean>(false);
  const handleCloseList = () => setOpenMagasins(false);
  const [ensembleValues, setEnsembleValues] = useState<ProduitQuantite[]>([]);
  const handleClose = () => {
    setOpenProd(false);
  };
  const handleClose2 = () => {
    setOpenRemp(false);
  };
  const [ptr, setPtr] = useState<string | undefined>(
    prendLaPlaceDe ? prendLaPlaceDe.toString() : undefined
  );
  const [prod, setProd] = useState<string | undefined>(
    row !== null ? row.toString() : undefined
  );
  const { data: ensemble = [] } = useGetEnsembleQuery(prod ? prod : "", {
    skip: !prod || prod.length < 6,
  });
  const [getIt] = useLazyGetDefaultSectionQuery();
  const [success, setSuccess] = useState<boolean>(false);
  const [listMags, setListMags] = useState<any[]>([]);
  const [deb, setDeb] = useState<Dayjs | null>(null);
  const [fin, setFin] = useState<Dayjs | null>(null);
  const [addPlanogramme] = useAddPlanogrammeMutation();
  const [trigger] = useLazyGetBannieresQuery();
  const [updatePlanogrammeProduits] = planoAPI.endpoints.updatePlanogrammeProduits.useMutation();
  const [error, setError] = React.useState<DateValidationError | null>(null);
  const [valid, setValid] = useState<boolean>(false);
  const [section, setSection] = useState<number | undefined>(
    row !== null ? activeSectionNum : undefined
  );
  const [plateau, setPlateau] = useState<number | null>(null);
  const [remplacer, setRemplacer] = useState<boolean>(true);


  const dispatch = useAppDispatch();
  const handleCardClick = (ptr: number) => {
    setProd(padZerosLeft(ptr, PTR_LENGTH));
    setOpenProd(false);
  };
  const handleCardClick2 = (ptr: number) => {
    setPtr(padZerosLeft(ptr, PTR_LENGTH));
    setOpenRemp(false);
  };
  const [recommended, setRecommended] = useState<Section>();
  const [planoQuantite, setPlanoQuantite] = useState<number>(1);

  useEffect(() => {
    trigger({ InclMag: true, treeView: false });
  }, [trigger]);

  const getSection = async () => {
    getIt({
      ptr: prod!.toString(),
      arg: "true",
    })
      .unwrap()
      .then((response) => {
        if (response.length > 0) {
          setSection(response[0].plans_seq);
          setRecommended(response[0]);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (prod !== undefined && prod.length >= 6) getSection();
  }, [prod]);

  useEffect(() => {
    let g = listMagsPlano.map((e) => ({
      ...e,
      isChecked: true,
      disabled: defaultDisabled,
    }));
    setListMags(g as any);
  }, [defaultDisabled, listMagsPlano]);

  useEffect(() => {
    setEnsembleValues([]);
  }, [ensemble.length]);

  const errorMessage = React.useMemo(() => {
    error === null ? setValid(true) : setValid(false);
    switch (error) {
      case "invalidDate": {
        return "Le format est invalide";
      }
      default: {
        return "";
      }
    }
  }, [error]);

  const handleCloses = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") return;
    setSuccess(false);
  };
  const handleSelectedMags = (list: any) => {
    let listMags = list.flatMap((e: any) => {
      return e.magasin.filter((x: any) => x.isChecked === true);
    });
    setListMags(listMags);
    handleCloseList();
  };
  const [noGo, setNoGo] = useState<boolean>(false);
  useEffect(() => {
    if (prod !== undefined && section !== undefined && listMags.length > 0) {
      setNoGo(true);
    } else {
      setNoGo(false);
    }
  }, [prod, section, listMags]);

  const handleSubmit = async () => {
    let removeDisabled = listMags.filter((e) => e.disabled === false);
    let requestsToSend = removeDisabled.map((item: any) => {
      let data = {
        mag_num: item.mag_num,
        plans_seq: section,
        prod_num: prod || 0,
        plano_trsf_dt_entree: deb !== null ? deb?.format("YYYY/MM/DD") : null,
        plano_trsf_dt_sortie: fin !== null ? fin?.format("YYYY/MM/DD") : null,
        plano_prod_num_remp: ptr || 0,
        plano_qte: planoQuantite,
        plano_plateau: plateau,
        plano_remplacer: remplacer
      };

      return new RequestToSend(
        `Ajout planogramme ${item.mag_nom}`,
        addPlanogramme,
        (value: any) => {
          if (ensemble.length > 0)
            dispatch(
              addRequestToSend(
                new RequestToSend(
                  `Sauvegarde produit/ensemble ${item.mag_nom}`,
                  updatePlanogrammeProduits,
                  () => {},
                  { planoSeq: value.plano_seq },
                  ensembleValues,
                  ["planogrammeProduits"]
                )
              )
            );
        },
        {},
        data,
        []
      );
    });
    dispatch(addRequestsToSend(requestsToSend));
  };

  const handleDelete = (index: number) => {
    const updatedList = listMags.filter((e, i) => i !== index);
    setListMags(updatedList);
  };

  return (
    <Box 
      display={"flex"} 
      flexDirection={"column"} 
      data-component="form-new-produit"
    >
      <GenericModal
        open={openProd}
        handleClose={handleClose}
        title="PTR"
        style={getModalStyle}
      >
        <PTRModal handleCardClick={handleCardClick} />
      </GenericModal>
      <GenericModal
        open={openRemp}
        handleClose={handleClose2}
        title="PTR"
        style={getModalStyle}
      >
        <PTRModal handleCardClick={handleCardClick2} />
      </GenericModal>
      <GenericModal
        open={openMagasin}
        handleClose={handleCloseList}
        style={getModalStyle}
        title="Liste de tous les magasins"
      >
        <ListMagasinsModal
          selectedMags={handleSelectedMags}
          listMags={listMags}
        />
      </GenericModal>
      <GenericModal
        open={showModalPlanoProduits}
        handleClose={() => setShowModalPlanoProduits(false)}
        title="Produits inclus"
        style={getModalStyle}
      >
        <PlanoProduitsModal
          prodNum={Number(prod!)}
          ensembleValues={ensembleValues}
          closeModal={() => setShowModalPlanoProduits(false)}
          update={(values: any) => {
            setEnsembleValues(values);
          }}
        />
      </GenericModal>
      <Snackbar
        open={success}
        autoHideDuration={6000}
        onClose={handleCloses}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity="success" variant="filled" onClose={handleCloses}>
          {" "}
          La modification a été enregistré
        </Alert>
      </Snackbar>
      <Box sx={{ display: "flex" }}>
        <Box
          onClick={() => {
            setOpenMagasins(true);
          }}
          className=".MuiInputBase-input"
          sx={{
            display: "flex",
            flexWrap: "wrap",
            width: "95%",
            border: "1px solid rgba(0, 0, 0, 0.25)",
            m: 1,
            borderRadius: "5px",
            p: 1,
            minHeight: "56px",
            "&:hover": {
              border: "1px solid black",
              cursor: "pointer",
            },
          }}
        >
          {listMags.length > 0 ? (
            listMags.map((e: any, i: number) => (
              <Chip
                label={e.mag_nom}
                sx={{ m: 0.5, display: e.disabled ? "none" : "" }}
                onDelete={!e.disabled ? () => handleDelete(i) : undefined}
                key={i}
              />
            ))
          ) : (
            <Typography
              sx={{
                color: "rgba(0, 0, 0, 0.50)",
                display: "flex",
                alignItems: "center",
                ml: 1,
              }}
            >
              Choisir magasin
            </Typography>
          )}
        </Box>
        <Button onClick={() => setOpenMagasins(true)} sx={{ width: "5%" }}>
          <SearchIcon />
        </Button>
        
          
        
      </Box>
      <Box sx={{ display: "flex" }}>
        <Box display={"flex"} flexDirection={"column"} width={"95%"}>
          <Box display={"flex"}>
            <TextField
              type="number"
              disabled={row !== null ? true : false}
              label="Produit"
              value={prod || ""}
              onChange={(event) => {
                if (event.currentTarget.value.length <= PTR_LENGTH)
                  setProd(
                    event.currentTarget.value.length > 0
                      ? event.currentTarget.value
                      : undefined
                  );
              }}
              sx={{
                m: 1,
                width: "15rem",
                color: "#233044",
                background: "white",
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button onClick={() => setOpenProd(true)}>
                      <SearchIcon />
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
            {recommended !== undefined ? (
              <Autocomplete
                options={sections}
                defaultValue={recommended}
                value={recommended}
                key={"asdaasdasdasdsd"}
                disabled={row !== null ? true : false}
                getOptionLabel={(sec) => `${sec.plans_nom}`}
                onChange={(e, value) => {
                  setSection(value?.plans_seq);
                  setRecommended(undefined);
                }}
                onInputChange={async (event, newInputValue) => {
                  event?.stopPropagation();
                }}
                sx={{ width: "15rem", m: 0.5 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Section"
                    sx={{ m: 0.5, color: "#233044", background: "white" }}
                  />
                )}
              />
            ) : (
              <Autocomplete
                key={"asdasd"}
                options={sections}
                disabled={row !== null ? true : false}
                getOptionLabel={(sec) => `${sec.plans_nom}`}
                defaultValue={
                  row !== null
                    ? sections.find((e) => e.plans_seq === activeSectionNum)
                    : null
                }
                onChange={(e, value) => {
                  setSection(value?.plans_seq);
                }}
                onInputChange={async (event, newInputValue) => {
                  event?.stopPropagation();
                }}
                sx={{ width: "15rem", m: 0.5 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Section"
                    sx={{ m: 0.5, color: "#233044", background: "white" }}
                  />
                )}
              />
            )}
            <TextField
              label="Quantité"
              type="number"
              sx={{ width: "75px", m: 1 }}
              InputLabelProps={{
                shrink: true,
              }}
              value={planoQuantite}
              InputProps={{ inputProps: { min: 1, max: 100 } }}
              onChange={(e) => {
                if (e.target.value !== "") {
                  setPlanoQuantite(Number(e.target.value));
                }
              }}
              disabled={ensemble.length > 0}
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
            <TextField
              type="search"
              label="Prend la place de"
              disabled={prendLaPlaceDe ? true : false}
              value={ptr ? padZerosLeft(ptr, PTR_LENGTH) : ""}
              onChange={(event) => {
                setPtr(event.currentTarget.value);
              }}
              onBlur={() => {
                if (ptr) setPtr(padZerosLeft(ptr!, PTR_LENGTH));
              }}
              sx={{
                m: 1,
                width: "15rem",
                color: "#233044",
                background: "white",
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      onClick={() => setOpenRemp(true)}
                      disabled={prendLaPlaceDe ? true : false}
                    >
                      <SearchIcon />
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
            <DatePicker
              value={deb}
              label="Date d'entrée"
              onChange={(event) => {
                setDeb(event);
              }}
              sx={{ m: 1, width: "15rem" }}
              onError={(newError) => setError(newError)}
              slotProps={{
                textField: {
                  helperText: errorMessage,
                },
              }}
              format="DD/MM/YYYY"
            />
            <DatePicker
              value={fin}
              label="Date de sortie"
              onChange={(event) => {
                setFin(event);
              }}
              sx={{ m: 1, width: "15rem" }}
              onError={(newError) => setError(newError)}
              slotProps={{
                textField: {
                  helperText: errorMessage,
                },
              }}
              format="DD/MM/YYYY"
            />
            <TextField
              value={plateau}
              label="Plateau"
              type="number"
              sx={{ m: 1, width: "15rem" }}
              onChange={(event) => {
                setPlateau(Number(event.currentTarget.value))
              }}
            /> 
            <FormControlLabel label="Remplacé" checked={remplacer} control={<Checkbox />} onChange={(_event, checked) => setRemplacer(checked)}/>
          </Box>
          {ensemble.length > 0 && (
            <Box
              sx={{
                display: "inline-flex",
                flexDirection: "column",
              }}
            >
              <TextField
                type="search"
                label="Produits inclus"
                value={
                  ensembleValues
                    .map((e) => padZerosLeft(e.prod_num, PTR_LENGTH))
                    .join(", ") || ""
                }
                sx={{
                  m: 1,
                  color: "#233044",
                  background: "white",
                }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Button
                        onClick={() => {
                          setShowModalPlanoProduits(true);
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          )}
        </Box>
        <span
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            width: "5%",
            justifyContent: "center",
          }}
          className={`save-wrapper ${!noGo || !valid ? "custom-disabled" : ""}`}
          onClick={handleSubmit}
        >
          <span className={`k-icon k-font-icon k-i-save k-icon-xl`}></span>
        </span>
      </Box>
    </Box>
  );
}

export default React.memo(FormNewProduit);
